export const mapEmployeeProfileDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    title: dto.title,
    summary: dto.summary,
    birthDate: dto.birth_date,
    skills: dto.skills,
    sections: dto.sections,
    hasPhoto: !!dto.has_photo,
});
